import { ChangeDetectionStrategy, Component, effect, inject, Input, Signal, signal, WritableSignal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { EMPTY, Observable, switchMap } from "rxjs";
import { IBankruptcyResult } from "src/app/search/models";
import { AppService } from "src/app/services/app.service";
import { EntitySearchService } from "src/app/services/entity-search.service";
import { ICaseViewModel, WebUserRight } from "src/app/shared/models";
import { BankruptcyScoreComponent } from "../bankruptcy-score/bankruptcy-score.component";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { CreditScoreComponent } from "../credit-score/credit-score.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-case-score',
  templateUrl: './case-score.component.html',
  styleUrls: ['./case-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, BankruptcyScoreComponent, CreditScoreComponent, TranslateModule],
  standalone: true
})
export class CaseScoreComponent{

    caseModelSignal : WritableSignal<ICaseViewModel> = signal(null); 

    #appService : AppService = inject(AppService);
    #entitySearchService: EntitySearchService = inject(EntitySearchService);

    @Input()
    set caseModel(model : ICaseViewModel)
    {
        if(model?.number != this.caseModelSignal()?.number)
            this.caseModelSignal.set(model)
    }

    bankruptcyScore$ : Observable<null | IBankruptcyResult> = toObservable(this.caseModelSignal).pipe(switchMap(model => {
        if(model == null) return EMPTY;

        return this.#entitySearchService.bankruptcyScore('Enin', this.caseModelSignal()?.debtor?.socialNumber);
    }))
    
    bankruptcyScoreSignal : Signal<null | IBankruptcyResult> = toSignal(this.bankruptcyScore$);
   

    scoreTab: ScoreTab = 'None';

    displayScoreSignal = toSignal(this.#appService.userHasRight(WebUserRight.ViewScore))
    displayBankruptcySignal = toSignal(this.#appService.userHasRight(WebUserRight.Enin))

    selectOnLoadEffect = effect(() =>{
        if(this.displayScoreSignal()) this.scoreTab = 'Credit';
        if(this.displayBankruptcySignal() && this.scoreTab == 'None') this.scoreTab = 'Bankruptcy';
    })

}




type ScoreTab = 'None' | 'Credit' | 'Bankruptcy';